import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import { graphql } from "gatsby"
import React from "react"
import { css } from "styled-components"
import ContactForm from "../../components/shared/contact"
import Footer from "../../components/shared/footer"
import Hero from "../../components/shared/hero"
import useSiteMetadata from "../../components/shared/hooks/useSiteMetadata"
import Layout from "../../components/shared/layout"
import SEO from "../../components/shared/seo"
import { FAQ_TYPENAME } from "../organisms/faq-section"
import { richTextObjectToString } from "../util/contentful-data"
import Sections from "./section"

const ContentfulPage = ({ location, data: { page } }) => {
  // Search for an FAQ section and retrieve the questions and answers if it exists
  const faqs = page?.components
    ?.find((c) => c.__typename === FAQ_TYPENAME)
    ?.faqItems.map((f) => ({
      "@type": "Question",
      name: f.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: richTextObjectToString(f.body),
      },
    }))

  // Convert the faqs to Google structured data
  const richResults = faqs && {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs,
  }
  const metadata = useSiteMetadata()
  return (
    <Layout location={location}>
      <SEO
        title={page?.seoTitle || metadata.title}
        description={
          page?.seoDescription?.seoDescription || metadata.description
        }
        richResults={richResults}
      />
      {page.hero && (
        <Hero
          title={page.hero.title}
          description={documentToPlainTextString(
            JSON.parse(page.hero.body.raw)
          )}
          overlayStyle={
            page.hero.overlayColour
              ? css`
                  background-color: ${page.hero.overlayColour.hex};
                  mix-blend-mode: multiply;
                `
              : undefined
          }
          sizes={{
            sm: page.hero.backgroundImage.mobile.fluid,
            md:
              page.hero.backgroundImage.tablet &&
              page.hero.backgroundImage.tablet.fluid,
            lg:
              page.hero.backgroundImage.desktop &&
              page.hero.backgroundImage.desktop.fluid,
          }}
        />
      )}
      <Sections components={page.components || []} website="Industries" />
      <ContactForm />
      <Footer />
    </Layout>
  )
}

export default ContentfulPage

export const ContentfulPageQuery = graphql`
  query ($id: String) {
    page: contentfulWebsitePage(contentful_id: { eq: $id }) {
      seoTitle
      seoDescription {
        seoDescription
      }
      ...Hero
      ...Sections
    }
  }
`
